<template>
  <div
    v-if="!measure.displayType.type === 'bar_total' && showZeroMeasureWarning()"
    :class="'zero_count_' + measure.displayType.type"
    :title="deriveTitle()"
    style="min-width: 100%"
  ><v-icon color="red" class="mr-4">mdi-alert</v-icon>0
  </div>
  <div
    v-else-if="measure.displayType.type === 'bar'"
    :class="'bar '"
    @click="clicked($event)"
    @contextmenu="openContextMenu($event)"
    :title="deriveTitle()"
  >
    <div class="inner" :style="`width: ${barWidthPct.toFixed(2)}%`"></div>
    <div :class="barIsSmall ? 'valueOffset' : 'value'">
      {{ formattedValue.value }}
    </div>
  </div>
  <div
    style="display: flex; min-width: 100%"
    v-else-if="measure.displayType.type === 'bar_total'"
  >
    <div
      class="bar-number-number"
      :style="barNumberStyle"
      @click="clicked($event)"
      @contextmenu="openContextMenu($event)"
      :title="showMeasureAlert() ? null : deriveTitle()"
    >
      <span v-if="measure.barAlertPx" class="bar-number-alert" :style="{ flex: `0 0 ${measure.barAlertPx}px`, width: `${measure.barAlertPx}px` }">
        <v-icon v-if="showZeroMeasureWarning()" color="red" :title="measure.title + ' is zero'">mdi-alert</v-icon>
        <v-icon v-else-if="showMeasureAlert()" color="orange" :title="measure.alertLevelMessage">mdi-alert</v-icon>
      </span>
      <template v-else>
        <v-icon v-if="showZeroMeasureWarning()" class="bar-number-icon" color="red" :title="measure.title + ' is zero'">mdi-alert</v-icon>
        <v-icon v-if="showMeasureAlert()" class="bar-number-icon" color="orange" :title="measure.alertLevelMessage">mdi-alert</v-icon>
      </template>
      <span class="bar-number-value">{{ formattedValue.value }}</span>
    </div>
    <div
      class="bar-number-container"
      @click="clicked($event)"
      @contextmenu="openContextMenu($event)"
      :title="deriveTitle()"
    >
      <div
        class="bar-number-bar"
        :style="`width: ${barWidthPct.toFixed(2)}%`"
      ></div>
    </div>
    <div
      class="bar-number-percent"
      @click="clicked($event)"
      @contextmenu="openContextMenu($event)"
      :title="deriveTitle()"
    >
      {{ (barWidthPct >= 100 ? barWidthPct.toFixed(0) : barWidthPct.toFixed(1)) + " %" }}
    </div>
  </div>
  <div v-else-if="measure.linked_docs_column && item[measure.column]"
    :class="item[measure.column] ? 'islink' : ''"
    @click="$emit('showLinkedDocs', item[measure.linked_docs_column])">
   <!-- <div style="float: right; padding: 3px; border-radius: 20px;">  :title="item[measure.linked_docnames_column]" -->
    <v-tooltip  v-if="item[measure.column]" min-width="400px" left>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on">{{formattedValue.value}}</span>
      </template>Click to view documents.<br/>
      {{ measure.title }} based on:
      <div style="min-width: 390px;" v-for="(t,ti) in item[measure.linked_docnames_column]" :key="'t' + ti">
     - {{ t }}
      </div>
    </v-tooltip>
    <!-- <div v-else-if="item[measure.column] || item[measure.column] === 0">0</div> -->
  </div>
  <div
    v-else
    :class="deriveClass()"
    @click="clicked($event)"
    @contextmenu="openContextMenu($event)"
    :title="deriveTitle()"
    style="min-width: 100%; height: 100%;"
    :style="deriveStyle()"
  >
    <v-icon v-if="showMeasureAlert()" color="orange" class="mr-4" :title="measure.alertLevelMessage">mdi-alert</v-icon>
    {{ formattedValue.value }}
    <CheckBox v-if="selectable && formattedValue.value && !measure.hideSelector" 
      :item="item" style="float: right; margin-left: 12px; margin-top: -3px;"
      @click="clicked($event)"
    ></CheckBox>
  </div>
</template>
	
<script>
import CheckBox from "@/components/jobArchitecture/CheckBox";
import utils from "@/common/utils.js";
export default {
  name: "MeasureDisplay",
  props: {
    item: Object,
    measure: Object,
    selectable: Boolean,
    backColour: String,
    textColour: String,
    isTitle: Boolean,
    longTitle: Boolean,
    highlightSmall: Boolean,
  },
  data: function () {
    return {
      utils: utils,
      // formattedValue: null,
    };
  },
  components: { CheckBox, },
  watch: {},
  computed: {
    propName() {
      return this.measure.id;
      // return (
      //   this.measure.type + (this.measure.aggregation === "mean" ? "_mean" : "")
      // );
    },
    title() {
      return this.longTitle ? this.measure.title : this.measure.abbreviation;
    },
    barWidthPct() {
      // const divisor =
      //   this.display === "bar_total"
      //     ? this.measure.total_value
      //     : this.measure.max_value;
      return Number(this.item[this.propName + this.measure.displayType.percentColumn]) || 0;
      // return (100 * value) / divisor;
    },
    barIsSmall() {
      if (!this.$parent.$el) return true;
      return (this.$parent.$el.clientWidth * this.barWidthPct) / 100 < 50;
    },
    barNumberStyle() {
      // fixed width (widest value in the column, measured by the layout pass) so
      // the numbers right-align beneath each other and every bar container sits
      // at the same position with the same width
      const px = this.measure.barNumberPx;
      if (!px) return null;
      return { flex: `0 0 ${px}px`, width: `${px}px`, maxWidth: `${px}px` };
    },
    formattedValue() {
      return this.formatValue();
    },
  },
  created: function () {
    // this.formattedValue = this.formatValue();
  },
  methods: {
    formatValue() {
      if (this.isTitle) return this.title;
      const value = this.deriveValue();
      let returnValue = { value: value, width: 0, rawValue: value };
      if (this.measure.column_basis && this.item[this.propName + "_single_comparator"]) {
        returnValue.value = this.item[this.propName + "_single_comparator_text"];
      } else if (this.measure.numberFormat) {
        returnValue.value = this.utils.formatNumber(value, this.measure.numberFormat);
      } else {
        if (this.measure.format === "pct")
          returnValue.value = `${(Number(value) || 0).toFixed(2)}%`;
        else if (value === undefined) returnValue.value = "";
        else if (value) returnValue.value = this.numberWithCommas(value);
      }
      returnValue.width = (returnValue.value + "").length * 5;
      return returnValue;
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    deriveValue() {
      return Number(this.item[this.propName]);
    },
    deriveTitle() {
      let measureTitle = this.measure?.title;
      if (this.measure.column_basis && this.item[this.propName + "_single_comparator"]) {
        return this.measure.single_comparator_tooltip || "Insufficient data to compare";
      } else if (this.item && this.measure.aggregation === "mean") {
        let value = this.item[this.measure.type + "_std_dev"];
        let valueCount = this.item[this.measure.type + "_mean_value_count"];
        return valueCount
          ? `Mean ${measureTitle} (standard deviation of ${value.toFixed(
              0
            )} based on ${valueCount} document${valueCount > 1 ? "s" : ""})`
          : null;
      } else {
        let title =
          measureTitle +
          (this.selectable
            ? `: Click to ${
                this.item.selected ? "un" : ""
              } select item. Right click to see linked documents.`
            : "");

        if (this.item && this.measure.isMatchCount) {
          title = `Click to view ${this.measure.description}.`;
        }
        return title;
      }
    },
    showZeroMeasureWarning() {
      return !this.measure.aggregation_exclude_zero && this.deriveValue() === 0;
    },
    showMeasureAlert() {
      if (!this.measure.alertLevelLT && !this.measure.alertLevelGT) return false;
      const value = this.measure.displayType.type === 'bar_total' ? this.barWidthPct : this.deriveValue();
      if (this.measure.alertLevelLT && this.measure.alertLevelGT)
        return value <= this.measure.alertLevelLT && value >= this.measure.alertLevelGT;
      else if (this.measure.alertLevelLT)
        return value <= this.measure.alertLevelLT;
      else 
        return value >= this.measure.alertLevelGT;
    },
    deriveStyle() {
      let style = null;
      if (this.measure.highlightRules?.length) {
        const val = this.formattedValue;
        if (this.measure.single_comparator_text && this.measure.single_comparator_text === val.value) {
          style = { backgroundColor: "#EEEEEE" }
        } else {
          let rule = this.utils.determineHighlightRule(this.measure, val.rawValue, !!this.item.failsHighlight);
          if (rule) 
            style = rule.style;
        }
        // else // default
        //   style = { color: "#000000", backgroundColor: "#FFFFFF" };
      }
      if (this.measure.alignment === "left") {
        style = {...style, ...{ textAlign: "left"} };
      } else if (this.measure.alignment === "center") {
        style = {...style, ...{ textAlign: "center"} };
      }
      return style;
    },
    deriveClass() {
      if (this.isTitle)
        return (
          this.measure.type + (this.isTitle && this.longTitle ? " long " : "")
        );
      let value = this.deriveValue();
      value = value === 0 ? "0" : value || "";
      // if (!value || (value === "0" && this.measure.aggregation_exclude_zero))
      if (!value)
        return "_hidden";
      else {
        const valNum = Number(value) || 0;
        const isSmall = this.highlightSmall ? valNum < 5 : false;
        let ret =
          this.measure.type +
          (value === "0" ? " _zero" : "") +
          (isSmall ? " _small" : "") +
          (this.selectable && this.item[this.propName] && !this.measure.hideSelector
            ? this.item.selected
              ? " _selected"
              : " _selectable"
            : "") +
          (this.backColour && this.measure.aggregation !== "mean"
            ? " " + this.backColour
            : "") +
          (this.textColour && this.measure.aggregation !== "mean"
            ? " text--" + this.textColour
            : "") +
          (this.measure.alignRight ? " float-right" : "") +
          (this.measure.aggregation === "mean"
            ? " " + this.item[this.measure.type + "_category"]
            : "");
        if (!this.selectable && this.measure.allowDrillDown) ret += " islink";
        return ret;
      }
    },
    openContextMenu(e) {
      if (
        this.item &&
        (this.measure.type === "job_count" || this.measure.isMatchCount)
      )
        this.$emit("showDocList", e, this.item, this.measure);
    },
    clicked(e) {
      if (this.measure.allowDrillDown) this.$emit("drilldown", this.item, this.measure);
      if (this.selectable && !this.measure.hideSelector) this.$emit("click");
      if (this.item && this.measure.isMatchCount)
        this.$emit("showDocList", e, this.item, this.measure);
    },
  },
};
</script>
	
<style scoped lang="scss">
._hidden {
  display: none;
}
div {
  max-width: 100px;
}
.bar {
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  font-size: 16px;
  > .inner {
    max-width: 100%;
    height: 20px;
    background-color: rgb(231, 230, 230);
    border: solid #c2c1c1 1px;
    border-radius: 5px;
  }
  > .valueOffset {
    padding-left: 5px;
  }
  > .value {
    position: absolute;
    top: 0;
  }
}
.score,
.salary {
  text-align: right;
  border: solid grey 1px;
  border-radius: 8px;
  font-size: 12px;
  padding-right: 5px;
  /* padding: 4px 2px 3px 0; */
  overflow: hidden;
  margin-left: 5px;
  white-space: nowrap;
}
.zero_count_text,
.zero_count_bar,
.zero_count_bar_total,
.employee_count,
.employee_percentage,
.job_count,
.similar_content_same_name,
.different_content_same_name,
.similar_content_different_name,
.leaf_node_count {
  text-align: right;
  border-radius: 0px;
  padding: 0px;
  font-family: "DM Sans" !important;
  // font-family: "Open Sans" !important;
  font-weight: 400;
  font-size: 14px;
  color: black !important;
  line-height: 20.83px;
  letter-spacing: 0.5px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.zero_count_bar {
  text-align: center;
}
.zero_count_bar_total {
  text-align: left;
  font-family: "DM Sans" !important;
  font-weight: 400;
  color: black !important;
  font-size: 14px;
  line-height: 22.4px;
}
/*
.employee_count,
.employee_percentage {
  border: solid #c2c1c1 1px;
  background-color: rgb(231, 230, 230);
  font-style: italic;
} */
.employee_count._zero,
.employee_percentage._zero {
  /* border: solid red 1px; 
   font-style: italic; */
  background-color: rgb(236, 202, 202);
}
.employee_percentage._small {
  border: solid rgb(253, 205, 114) 3px;
  background-color: rgb(255, 239, 198);
}
.job_count._zero {
  background-color: #ff000026;
  /* border: solid #f19e9e 2px; */
  padding-right: 5px;
  color: black;
  color: #a90404;
}
.job_count {
  background-color: transparent;
  border: none;
}
._selected {
  border: none;
}
._selectable,
._selected {
  cursor: pointer;
}
._selectable:hover,
._selected:hover {
  background-color: transparent;
  border: none;
  color: black;
}
.leaf_node_count {
  border: none;
}

._low {
  background-color: #ff6161;
  color: white;
}
._mid {
  background-color: lightgreen;
}
._high {
  background-color: green;
  color: white;
}
.different_content_same_name {
  background-color: #009688;
  border: solid #73b6f5 3px;
  color: white;
  cursor: pointer;
}
.similar_content_same_name {
  background-color: #3f51b5;
  border: solid #73b6f5 3px;
  color: white;
  cursor: pointer;
}
.similar_content_different_name {
  background-color: #9a3fb5;
  border: solid #73b6f5 3px;
  color: white;
  cursor: pointer;
}
.similar_content_same_name:hover,
.different_content_same_name:hover,
.similar_content_different_name:hover {
  background-color: #5d748a;
  color: white;
}
.long {
  max-width: unset;
}

.bar-number-number {
  // right-justified flex: warning icons sit left of the value and, in a fixed
  // width section, can never push the bar container out of alignment — if the
  // section overflows, the icons clip on the left rather than shifting the bar
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  flex: 0 0 auto;
  min-width: 0;
  max-width: none;
  padding-left: 12px;
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 14px;
  color: black !important;
  line-height: 22.4px;
  overflow: hidden;
  white-space: nowrap;
}
.bar-number-icon {
  flex: 0 0 auto;
}
.bar-number-alert {
  // reserved slot: present on every row of a column that can show warnings, so
  // the value and bar positions are identical whether or not this row alerts
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}
.bar-number-value {
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.bar-number-container {
  background-color: white;
  flex: 1 1 auto;
  min-width: 40px;
  // let the bar absorb whatever the fixed-width number/percent sections leave,
  // overriding the generic 100px div cap, so all bars share one width
  max-width: none;
  height: 22px;
  border: solid 1px #dddddd;
  margin-left: 5px;
  margin-right: 5px;
}
.bar-number-bar {
  background-color: #50b3cb;
  height: 100%;
}
.bar-number-percent {
  // fixed width + right alignment keep the percents (and therefore the bar
  // containers) vertically aligned across rows
  text-align: right;
  flex: 0 0 52px;
  width: 52px;
  max-width: 52px;
  min-width: 0;
  font-family: "DM Sans" !important;
  font-weight: 400;
  font-size: 14px;
  color: black !important;
  line-height: 22.4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.islink {
  // text-decoration: underline; 
  cursor: pointer;
}
.islink:hover {
  // color: rgb(106, 230, 106);
  background-color: #eeeeee;
  opacity: 0.5;
}
</style>